import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloLink } from 'apollo-link';
import { onError } from 'apollo-link-error';
import { Router } from '@angular/router';

// constants
import { environment } from '../../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class GraphqlService {
	constructor(
		public apollo: Apollo,
		private httpLink: HttpLink,
		private router: Router
	) {
		const http = httpLink.create({ uri: environment.graphql_uri });

		const errorLink = onError(({ graphQLErrors, networkError }) => {
			if (graphQLErrors) {
				console.log('Error with code: ', graphQLErrors[0].extensions);

				graphQLErrors.map(({ extensions, message, locations, path }) => {});
			}
			if (networkError) {
				console.log(`[Network error]: ${networkError.message}`);
				// if (networkError.name === "HttpErrorResponse") {
				// this.router.navigate(["/"]);
				// }
			}
		});

		const authLink = new ApolloLink((operation, forward) => {
			const token = localStorage.getItem('token');

			operation.setContext({
				headers: {
					Authorization: token ? `JWT ${token}` : ''
				}
			});

			return forward(operation);
		});

		const mainLink = authLink.concat(errorLink);

		apollo.create({
			link: mainLink.concat(http),
			cache: new InMemoryCache(),
			defaultOptions: {
				query: {
					errorPolicy: 'all',
					fetchPolicy: 'network-only'
				}
			}
		});
	}
}
